import { Link } from "react-router-dom";

// Logo palette: shield navy + bone.
export const BRAND_NAVY = "#12436B";
export const BRAND_BONE = "#E3E0DB";

export const Mark = () => (
  <img src="/logo-shield.png" alt="" aria-hidden="true" className="h-11 w-auto" />
);

// Wordmark set exactly like the logo lockup: display face, caps, navy (or bone on dark).
export const Brand = ({ light = false, size = "md", className = "", testid }) => {
  const sizes = {
    sm: ["text-[0.95rem] tracking-[0.04em]", "text-[0.55rem] tracking-[0.2em]"],
    md: ["text-[1.15rem] tracking-[0.04em]", "text-[0.66rem] tracking-[0.2em]"],
    lg: ["text-2xl tracking-[0.03em] sm:text-3xl", "text-[0.8rem] tracking-[0.22em] sm:text-sm"],
  }[size];
  return (
    <span className={`inline-flex flex-col leading-none ${light ? "text-[#E3E0DB]" : "text-[#12436B]"} ${className}`} data-testid={testid}>
      <span className={`font-display block font-extrabold uppercase ${sizes[0]}`}>precise</span>
      <span className={`font-display block font-semibold uppercase opacity-90 ${sizes[1]}`}>it solution</span>
    </span>
  );
};

// Inline (single-line) version for running copy.
export const BrandInline = ({ light = false, className = "" }) => (
  <span className={`font-display font-extrabold uppercase tracking-[0.04em] ${light ? "text-[#E3E0DB]" : "text-[#12436B]"} ${className}`}>
    Precise <span className="font-semibold tracking-[0.12em]">IT Solution</span>
  </span>
);

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="site-logo" className="group flex items-center gap-2.5" aria-label="Precise IT Solution home">
    <img src="/logo-shield.png" alt="Precise IT Solution logo" className="h-11 w-auto transition-transform duration-500 group-hover:-rotate-6" />
    <Brand light={light} />
  </Link>
);
